import loggingService from '../util/loggingService'

var serviceName = 'disturbanceService'
var path = '/DisturbanceInstance/'
var isDebug = false

function put (http, disturbance) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, disturbance)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?disturbanceId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search by ' + searchObject.historicalRegisterStatusInstanceId)
    return http.post(path + 'Search', searchObject)
}

function getDisturbanceList () {
    return [
        {disturbanceTypeId: 1, description: 'None '},
        {disturbanceTypeId: 2, description: 'Erosion '},
        {disturbanceTypeId: 3, description: 'Vandalism '},
        {disturbanceTypeId: 4, description: 'Collection'},
        {disturbanceTypeId: 5, description: 'Structural damage '},
        {disturbanceTypeId: 6, description: 'Manual excavation'},
        {disturbanceTypeId: 7, description: 'Mechanical excavation'},
        {disturbanceTypeId: 8, description: 'Vehicle traffic '},
        {disturbanceTypeId: 9, description: 'Structural decay '},
        {disturbanceTypeId: 10, description: 'Grazing'},
        {disturbanceTypeId: 11, description: 'Construction/development '},
        {disturbanceTypeId: 12, description: 'Defacement'},
        {disturbanceTypeId: 13, description: 'Imminent Destruction'},
        {disturbanceTypeId: 14, description: 'Bioturbation'},
        {disturbanceTypeId: 15, description: 'Unknown'},
        {disturbanceTypeId: 16, description: 'Destroyed'}
    ]
}

export default {
    put: put,
    get: get,
    search: search,
    getDisturbanceList: getDisturbanceList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/disturbanceService.js